import {
  Button,
  Grid,
  Box,
  BottomNavigationAction,
  Avatar,
} from "@mui/material";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";

const MypageLoggedOut = () => {
  const cid = get_cid();
  const center = get_center(cid);

  return (
    <Grid
      container
      flex="1"
      width="100%"
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        sx={{
          width: "100%",
          height: "50px",
          background: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={center.logo} height="35px" />
      </Box>
      <Grid
        container
        flex="1"
        width="100%"
        direction="column"
        justifyContent="space-around"
        alignItems="center"
      >
        <Avatar
          sx={{
            width: cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
            height: cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
            border: "solid white 1px",
            boxShadow: 2,
            margin: cid !== "XXXXX" /*줌*/ ? "" : "7rem 0",
          }}
        ></Avatar>
        <Grid>내 수업은 로그인 후 볼 수 있습니다.</Grid>
        <Box
          style={{
            height: "50%",
          }}
        ></Box>
      </Grid>
    </Grid>
  );
};

export default MypageLoggedOut;
